// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/CalculationTemplate.yaml
// Generated: 2026-10-20T12:35:10.067Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateCalculationTemplate, UpdateCalculationTemplate, CalculationTemplate } from '@/types/forestry/CalculationTemplate';

/**
 * CalculationTemplate Service
 * CRUD operations for CalculationTemplate via the ABP API.
 */
export const calculationTemplateService = new EntityService<CalculationTemplate, CreateCalculationTemplate, UpdateCalculationTemplate>(
  '/api/forestry/calculationtemplate',
  'CalculationTemplate',
);
